import {
  DOCS_FORM_NAMES,
  FORM_DOWNLOADED_PDF_NAMES,
  PATIENT_DOCUMENTS,
} from "core/consts";
import { AuctionForm, TransitionalCare } from "core/types";
import { DownloadSectionWrapper } from "dsl/ecosystems/PatientForms/components";
import { useCreateTransitionalCarePdf } from "dsl/ecosystems/PatientForms/useCreateTransitionalCarePdf";
import { useTranslations } from "translations";
import { useDocumentHandling } from "../../useDocumentHandling";

export const TransitionalCareFormDownload = ({
  careseekerName,
  externalId,
  transitionalCare,
  userId,
}: {
  careseekerName: string;
  externalId: string;
  transitionalCare: Readonly<TransitionalCare | AuctionForm> | undefined;
  userId: string;
}) => {
  const translations = useTranslations();
  const createTransitionalCarePdf = useCreateTransitionalCarePdf();
  const { handleOpenPdf, handleSendToHis, progressOpenPdf, progressSendToHis } =
    useDocumentHandling({
      careseekerName,
      createPDFDocument: createTransitionalCarePdf,
      externalId,
      userId,
    });

  if (!transitionalCare) return null;

  return (
    <DownloadSectionWrapper
      body={
        translations.patientForms.transitionalCareForm.downloadSection.bodyText
      }
      lastUpdated={transitionalCare.updated_at!}
      pdfName={FORM_DOWNLOADED_PDF_NAMES[DOCS_FORM_NAMES.TRANSITIONAL_CARE]}
      progressOpenPdf={progressOpenPdf}
      progressSendToHis={progressSendToHis}
      title={
        translations.patientForms.transitionalCareForm.downloadSection.title
      }
      onClickPrint={() => handleOpenPdf({ transitionalCare })}
      onClickSendToHis={() =>
        handleSendToHis({
          documentType: PATIENT_DOCUMENTS.TRANSITIONAL_CARE,
          transitionalCare,
        })
      }
    />
  );
};
